import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import agentsHeroImage from "../../assets/area/Ajmal.jpg";
import rightHero from "../../assets/area/Ajmal_Makan_Sharjah_Waterfront_master_planhero.png";

export default function AgentsHero() {
  return (
    <Box
      sx={{
        minHeight: "85svh",
        display: "flex",
        alignItems: "center",
        position: "relative",
        backgroundImage: `url(${agentsHeroImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundColor: "var(--color-primary-dark)",
        overflow: "hidden",
      }}
    >
      {/* RESPONSIVE TEXT SCRIM */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 1,
          background: `
      linear-gradient(
        120deg,
        rgba(40, 40, 40, 0.45) 0%,
        rgba(40, 40, 40, 0.32) 40%,
        rgba(40, 40, 40, 0.18) 75%,
        rgba(40, 40, 40, 0.08) 100%
      )
    `,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 1,
          backgroundColor: "#000000",
          opacity: 0.2,
          transition: "background 0.3s, border-radius 0.3s, opacity 0.3s",
          //       background: `
          //   linear-gradient(
          //     180deg,
          //     rgba(10,10,10,0.22) 0%,
          //     rgba(10,10,10,0.15) 45%,
          //     rgba(10,10,10,0.28) 100%
          //   )
          // `,
        }}
      />

      <Container
        maxWidth="xl"
        sx={{
          position: "relative",
          zIndex: 2,
          pt: { xs: 14, md: 18 },
          pb: { xs: 10, md: 14 },
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1.1fr 0.9fr" },
            alignItems: "center",
            gap: { xs: 6, md: 10 },
          }}
        >
          {/* LEFT CONTENT */}
          <motion.div
            initial={{ opacity: 0, y: 45 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9 }}
          >
            <Typography
              sx={{
                letterSpacing: "0.28em",
                fontSize: 12,
                fontWeight: 600,
                color: "var(--color-gold)",
                mb: 3,
              }}
            >
              OUR REAL ESTATE ADVISORS
            </Typography>

            <Typography
              sx={{
                fontSize: {
                  xs: "1.9rem",
                  sm: "2.4rem",
                  md: "3.0rem",
                  lg: "3.4rem",
                },
                fontWeight: 600,
                lineHeight: 1.1,
                maxWidth: 780,
                mb: 3,
                textShadow: "0 20px 40px rgba(0,0,0,0.35)",
              }}
            >
              <Box component="span" sx={{ color: "var(--color-white)" }}>
                Where Property
              </Box>{" "}
              <Box component="span" sx={{ color: "var(--color-gold)" }}>
                Meets
              </Box>
              <br />
              <Box component="span" sx={{ color: "var(--color-white)" }}>
                People
              </Box>{" "}
              {/* <Box
                component="span"
                sx={{
                  color: "var(--color-gold)",
                  borderBottom: "2px solid var(--color-gold)",
                  paddingBottom: "4px",
                  display: "inline-block",
                }}
              >
                People
              </Box> */}
            </Typography>

            <Box
              sx={{
                width: 48,
                height: 2,
                backgroundColor: "var(--color-gold)",
                mb: 3,
              }}
            />

            <Typography
              sx={{
                fontSize: { xs: 14, md: 16 },
                lineHeight: 1.9,
                color: "rgb(255, 255, 255)",
                // color: "rgba(255,255,255,0.9)",
                textShadow: "0 20px 40px rgba(0,0,0,0.35)",
                maxWidth: 640,
              }}
            >
              Our agents are more than brokers — they are trusted advisors with
              deep market expertise, refined negotiation skills, and a
              client-first mindset. Each professional is committed to delivering
              clarity, confidence, and exceptional outcomes across every real
              estate journey.
            </Typography>
          </motion.div>

          {/* RIGHT ADVISORY PANEL */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.9, delay: 0.2 }}
          >
            <Box
              sx={{
                position: "relative",
                borderRadius: { xs: 4, md: "32px" },
                overflow: "hidden",
                boxShadow: "0 40px 90px rgba(0,0,0,0.25)",
                backgroundColor: "var(--color-white)",
              }}
            >
              {/* IMAGE BACKDROP */}
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  backgroundImage: `url(${rightHero})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  filter: "contrast(1.05) saturate(1.05)",
                }}
              />

              {/* IMAGE FADE OVERLAY */}
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background: `
          linear-gradient(
            90deg,
            rgba(255,255,255,0.98) 0%,
            rgba(255,255,255,0.95) 40%,
            rgba(255,255,255,0.88) 55%,
            rgba(255,255,255,0.6) 70%,
            rgba(255,255,255,0.15) 100%
          )
        `,
                }}
              />

              {/* CONTENT */}
              <Box
                sx={{
                  position: "relative",
                  zIndex: 2,
                  p: { xs: 3.5, md: 6 },
                  maxWidth: { xs: "100%", md: "65%" },
                }}
              >
                {/* EYEBROW */}
                <Typography
                  sx={{
                    color: "var(--color-gold)",
                    letterSpacing: "0.32em",
                    fontSize: 11,
                    fontWeight: 600,
                    mb: 2,
                  }}
                >
                  ADVISORY STANDARDS
                </Typography>

                {/* HEADLINE */}
                <Typography
                  sx={{
                    fontSize: { xs: "1.6rem", md: "2.1rem" },
                    fontWeight: 600,
                    lineHeight: 1.25,
                    color: "var(--color-text-primary)",
                    mb: 3,
                  }}
                >
                  Elevated Real Estate Advisory
                  {/* <br /> */}
                </Typography>

                {/* GOLD RULE */}
                <Box
                  sx={{
                    width: 42,
                    height: 2,
                    backgroundColor: "var(--color-gold)",
                    mb: 3.5,
                  }}
                />

                {/* POINTS */}
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: 2.2 }}
                >
                  {[
                    "Client-first representation",
                    "Deep local market insight",
                    "Strategic negotiation expertise",
                    "Transparent & ethical practices",
                  ].map((item, idx) => (
                    <Box
                      key={idx}
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 2,
                      }}
                    >
                      <Box
                        sx={{
                          mt: "6px",
                          width: 6,
                          height: 6,
                          borderRadius: "50%",
                          backgroundColor: "var(--color-gold)",
                          flexShrink: 0,
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: 15,
                          lineHeight: 1.8,
                          color: "var(--color-text-primary)",
                        }}
                      >
                        {item}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>

              {/* SOFT EDGE FADE (BOTTOM) */}
              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  height: 80,
                  background:
                    "linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1))",
                }}
              />
            </Box>
          </motion.div>
        </Box>
      </Container>
    </Box>
  );
}
